import React from 'react';
import PropTypes from 'prop-types';
import {FadeLoader} from 'halogenium';
import './loader.less';

const Loading = (props) => {
    return (
        <div className="spinner" style={{height: props.containerHeight}}>
            <FadeLoader size={props.size} color={props.color}/>
        </div>
    );
}

Loading.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
    containerHeight: PropTypes.string
}

Loading.defaultProps = {
    color: '#003152',
    size: '25px',
}

export default Loading;



// WEBPACK FOOTER //
// ./src/react/views/generic/LoadingView.jsx